export default "__VITE_ASSET__CwkUB2qt__"